(ns bp-clients.tv-app.utils.bff)

(def ^:private default-supported-events
  #{"tv_app_go_to_playlist_detail"})

(defn filter-not-supported-events
  "Right now this app supports one kind of event:
  tv_app_go_to_playlist_detail.

  But forseeing new events in the future, having this
  filter allow us to change returned data without breaking
  compatibility. In case backend returns something that
  do not make sense to an old app version, this item will
  be ignored."
  ([items]
   (filter-not-supported-events items default-supported-events))
  ([items supported-events]
   (filter #(contains? supported-events
                       (-> % :event :__typename))
           items)))

(def ^:private default-supported-types
  #{"tv_app_grid" "tv_app_carousel" "tv_app_tab_set"})

(defn filter-not-supported-types
  "Right now this app supports a set of component types:
  tv_app_grid, tv_app_carousel, tv_app_tab_set.

  But forseeing new events in the future, having this
  filter allow us to change returned data without breaking
  compatibility. In case backend returns something that
  do not make sense to an old app version, this item will
  be ignored."
  ([items]
   (filter-not-supported-types items default-supported-types))
  ([items supported-types]
   (filter #(contains? supported-types
                       (:__typename %))
           items)))
